import { SVGProps, Ref, forwardRef } from "react";

const CdkIcon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-name="Layer 1"
    viewBox="0 0 500 500"
    fill="currentColor"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Cdk Icon"
    {...props}
  >
    <title id="Cdk Icon">Cdk Icon</title>
    <path d="M0 0h500v500H0z" />
    <path
      d="M201.1 209.61c-1.09-.04-2.19.35-2.54 1.44l-.18 76.92c0 1.11.29 2.41 1.62 2.36 24.99-1.82 57.98 7.47 74.02-17.56 9.74-15.2 8.28-37.96-4.48-51.08-17.09-17.57-46.44-10.59-68.45-12.08Zm45.55 60.75c-1.08.49-5.14 1.86-6.1 1.86h-20.44v-44.14h20.44c1.41 0 6.19 1.79 7.53 2.6 13.41 8.06 13.26 33.04-1.43 39.68Zm95.77-28.41 31.46-29.59c.9-1.8.22-2.57-1.63-2.76-5.23-.51-16.48-.48-21.75 0-.52.05-1.04.01-1.52.29l-31.39 29.75c-1.11.09-.18-.37-.18-.54.41-8.94 0-18.48 0-27.5 0-1.34-1.59-1.88-2.72-1.98-4.23-.41-11.61-.3-15.93-.02-1.86.12-2.87.05-3.34 2.09l-.1 75.54c.07 1.29.37 3.08 1.99 3.08 5.7-.46 12.17.55 17.77 0 1.65-.16 2.13-.69 2.34-2.36l.07-23.09 9.87-8.94 26.98 34.18c.72.43 1.5.5 2.32.58 5.04.47 16.38.53 21.37-.01 1.2-.13 1.84-.31 1.97-1.64l-37.58-47.08Zm-169.93 21.99c-2.28-1.35-4.61 1.82-6.53 3.14-9.1 6.25-19.03 10.07-30.13 6.38-21.06-6.98-21.66-38.75-.83-46.38 9.58-3.51 19.23-.9 27.83 3.83 1.28.7 5.25 3.82 6.28 3.54.96-.26 7.69-7.57 8.86-8.9 2.08-2.35 4.46-3.81 1.59-6.3-8.8-7.67-29.11-12.68-40.56-12.05-28.37 1.58-47.74 26.71-40.34 54.6 9.52 35.93 55.49 38.66 81.27 18.52 1.3-1.01 4.13-2.77 3.59-4.59l-11.02-11.79Z"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);

const ForwardRef = forwardRef(CdkIcon);
export default ForwardRef;
